<template lang="tr">
  <div lang="tr" class="vertical-align-step-0 pb-4">

   
      <span class="product-header-field">{{$t('Almak istediğiniz hizmeti seçin')}}</span> 


      
      <div v-if="addressPackage && addressPackage.id">
        <div @click="isSelectedAddressPackage = !isSelectedAddressPackage" class="box-border2 selectable-field"
          v-bind:class="{ 'selected': isSelectedAddressPackage }">
          <div class="box-content-field">
            <div>
              
              <div class="new-product-top-field">
                <div class="new-product-top-field-inside">
                  <div class="check-field" />
                
                  <span class="new-product-name">{{ getProductName(addressPackage)}}</span>
                </div>
                <div class="new-badge-field">{{ $t('Yeni Paket') }}</div> 

              </div>
           
            </div>
            <span class="new-product-description">{{ getProductDescription(addressPackage)}}</span>

            <div class="">

              <ul
                    class="vertical-center features-spacing main-feature mt-4 features-half"
                  >
                    <li
                      v-for="feature in addressPackageFeatures"
                      :key="feature.text"
                      class="col-12"
              
                    >
                      <span class="d-flex align-items-start feature-item">
                        <span  class="feature-text">{{ feature.text }}</span>
                        <i
                          v-if="feature.tooltipOptions"
                          v-tippy="feature.tooltipOptions.text"
                          class="fa fa-info-circle feature-icon"
                        ></i>
                      </span>

                    </li>
                  </ul>


              </div>

            <hr />

            <div class="new-product-bottom-field">
              <div class="bottom-left-field">
                <div class="old-price-field overline"> 
                  <span class="old-price">{{formatPrice(338, '$')}} </span> 
                  <span class="fee-text"> {{
                    addressPackage.type === 'subscription' ? (addressPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                  }}</span>
                </div>
                <div class="new-price-field"> 
                  <span class="new-price">{{ formatPrice(addressPackage.net_price,addressPackage.currency)}} </span> 
                  <span class="fee-text">{{
                    addressPackage.type === 'subscription' ? (addressPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                  }}</span>
                </div>
              </div>

              <div class="bottom-right-field">
                <div class="price-badge-field">
                  <img src="/img/icons/lightning.svg" alt="price-badge" />
                  <span class="ml-1">{{$t('daha tasarruflu', {price: '%41'})}}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

     

      <div v-if="taxPackage && taxPackage.id">
        <div @click="isSelectedTaxPackage = !isSelectedTaxPackage"  class="box-border2 selectable-field"
          v-bind:class="{ 'selected': isSelectedTaxPackage }">
          <div class="box-content-field">
            <div>
              
              <div class="new-product-top-field">
                <div class="new-product-top-field-inside">
                  <div class="check-field" />
                
                  <span class="new-product-name">{{ getProductName(taxPackage)}}</span>
                </div>
                <div class="new-badge-field">{{ $t('Yeni Paket') }}</div> 

              </div>
           
            </div>
            <span class="new-product-description">{{ getProductDescription(taxPackage)}}</span>

          

              <div class="">

                <ul
                      class="vertical-center features-spacing main-feature mt-4 features-half"
                    >
                      <li
                        v-for="feature in taxPackageFeatures"
                        :key="feature.text"
                        class="col-12"

                      >
                        <span class="d-flex align-items-start feature-item">
                          <span  class="feature-text">{{ feature.text }}</span>
                          <i
                            v-if="feature.tooltipOptions"
                            v-tippy="feature.tooltipOptions.text"
                            class="fa fa-info-circle feature-icon"
                          ></i>
                        </span>

                      </li>
                    </ul>


                </div>
          

            <hr />

            <div class="new-product-bottom-field">
              <div class="bottom-left-field">
                <div class="old-price-field overline"> 
                  <span class="old-price">{{formatPrice(898, '$')}} </span> 
                  <span class="fee-text"> {{
                    taxPackage.type === 'subscription' ? (taxPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                  }}</span>
                </div>
                <div class="new-price-field"> 
                  <span class="new-price">{{ formatPrice(taxPackage.net_price,taxPackage.currency)}} </span> 
                  <span class="fee-text">{{
                    taxPackage.type === 'subscription' ? (taxPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                  }}</span>
                </div>
              </div>

              <div class="bottom-right-field">
                <div class="price-badge-field">
                  <img src="/img/icons/lightning.svg" alt="price-badge" />
                  <span class="ml-1">{{$t('daha tasarruflu', {price: '%22'})}}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


  <addressChangeConfirmationModal  :main-package="addressChangeProduct" ref="usAddressChangeConfirmationModal" @confirm-address-package="confirmAddressChangeProduct" />
  <usTaxPackageConfirmationModal :us-products="products" :company="company" @confirm="sendForm"  ref="usTaxPackageConfirmationModal"/>
  <usTaxConfirmationModal :features="usTaxConfirmFeatures" @confirm="taxConfirmationConfirm" @cancel="taxConfirmationCancel"  ref="usTaxConfirmationModal"/>
  </div>
</template>

<script>
import RegisterStore from '../../../stores/register';
import CompanyStore from '../../../stores/company';
import ProductStore from '@/stores/product';
import addressChangeConfirmationModal from '../../modals/addressChangeConfirmation.vue';
import usTaxConfirmationModal from '../../modals/usTaxConfirmation.vue';
import usTaxPackageConfirmationModal from '../../modals/usTaxPackageConfirmation.vue';

export default {
  components: {
    addressChangeConfirmationModal,
    usTaxPackageConfirmationModal,
    usTaxConfirmationModal,
  },
  props: {
    states: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      productsCodes: [
        'US_ADDRESS_PACKAGE_PRODUCT',
        'US_TAX_PACKAGE_PRODUCT',
        'US_RAAGENT_CHANGE_WYOMING',
        'US_RAAGENT_CHANGE_DELAWARE',
        'US_RAAGENT_CHANGE_TEXAS',
        'US_RAAGENT_CHANGE_FLORIDA',
        'US_1040_NR_FORM',
        'USITIN',
        'US_1065_FORM',
        'US_1120_FORM',
      ],
      products: [],
      secondaryProducts: [],
      company: {
        global_activity_area: null,
      },
      stateFeeProduct: {},
      addressPackage: {},
      isSelectedAddressPackage: false,
      taxPackage: {},
      isSelectedTaxPackage: false,
      addressChangeProduct: {},
      addressPackageFeatures: this.$t('Us Address Maddeleri'),
      taxPackageFeatures: this.$t('Us Tax Maddeleri'),
      callback: null,
      usTaxConfirmFeatures: this.$t('Us Tax Confirmation Maddeleri Transfer'),
    };
  },
  async created() {
    this.startWaiting();
    CompanyStore.dispatch('getCompany').then((s) => {
      const company = s.data.data[0];
      this.company = company;

      if (this.company.package) {
        if (this.company.package.includes('US_ADDRESS_PACKAGE_PRODUCT')) {
          this.isSelectedAddressPackage = true;
        }
        if (this.company.package.includes('US_TAX_PACKAGE_PRODUCT')) {
          this.isSelectedTaxPackage = true;
        }
      }

      this.startWaiting();
      ProductStore.dispatch('getProductsByCodes', {
        codes: this.productsCodes,
        companyTypeId: this.company.company_type_id,
        sort: true,
      })
        .then((s) => {
          this.products = s.data.data;
          const addressPackage = this.products.find((element) => element.code === 'US_ADDRESS_PACKAGE_PRODUCT');

          if (addressPackage) {
            this.addressPackage = addressPackage;
          }

          const taxPackage = this.products.find((element) => element.code === 'US_TAX_PACKAGE_PRODUCT');

          if (taxPackage) {
            this.taxPackage = taxPackage;
          }

          const uppercaseState = this.company.state.toUpperCase();
          const selectedStateProducts = this.products.filter(function (item) {
            if (item.code.includes(uppercaseState)) {
              return true;
            }
            return false;
          });
          if (selectedStateProducts.length) {
            const addressChangeProduct = selectedStateProducts.find((x) => x.code.includes('US_RAAGENT_CHANGE'));
            if (addressChangeProduct) {
              this.addressChangeProduct = addressChangeProduct;
            }
          }
        })
        .finally((s) => {
          this.endWaiting();
        });
    });
  },

  methods: {
    confirmAddressChangeProduct() {
      if (!this.isSelectedTaxPackage) {
        const element = this.$refs.usTaxConfirmationModal.$el;
        $(element).modal('show');
      } else {
        this.$refs.usTaxPackageConfirmationModal.calculateProducts();
        if (this.$refs.usTaxPackageConfirmationModal.getProductsArray().length) {
          const element = this.$refs.usTaxPackageConfirmationModal.$el;
          $(element).modal('show');
        } else {
          this.sendForm();
        }
      }
    },
    taxConfirmationCancel() {
      this.sendForm();
    },
    taxConfirmationConfirm() {
      this.isSelectedTaxPackage = true;
      this.$refs.usTaxPackageConfirmationModal.calculateProducts();
      if (this.$refs.usTaxPackageConfirmationModal.getProductsArray().length) {
        const element = this.$refs.usTaxPackageConfirmationModal.$el;
        $(element).modal('show');
      } else {
        this.sendForm();
      }
    },
    openSummaryModal(callback) {
      if (callback) {
        this.callback = callback;
      }

      if (this.isSelectedAddressPackage) {
        const element = this.$refs.usAddressChangeConfirmationModal.$el;
        $(element).modal('show');
      } else {
        if (!this.isSelectedTaxPackage) {
          const element = this.$refs.usTaxConfirmationModal.$el;
          $(element).modal('show');
        } else {
          this.$refs.usTaxPackageConfirmationModal.calculateProducts();
          if (this.$refs.usTaxPackageConfirmationModal.getProductsArray().length) {
            const element = this.$refs.usTaxPackageConfirmationModal.$el;
            $(element).modal('show');
          } else {
            this.sendForm();
          }
        }
      }
    },
    getCompanyData() {
      return CompanyStore.dispatch('getCompany');
    },
    getProductsData() {
      return ProductStore.dispatch('getProductsByCodes', {
        codes: this.productsCodes,
        companyTypeId: 12,
        sort: true,
      });
    },

    getPrice(prices) {
      const price = prices.find((x) => x.company_type_id === this.company.company_type_id).price;
      return price;
    },

    sendForm() {
      let packageData = [];

      if (this.isSelectedAddressPackage) {
        packageData.push(this.addressPackage.code);
        if (this.addressChangeProduct && this.addressChangeProduct.code) {
          packageData.push(this.addressChangeProduct.code);
        }
      }
      if (this.isSelectedTaxPackage) {
        packageData.push(this.taxPackage.code);
        const taxProducts = this.$refs.usTaxPackageConfirmationModal.getProductsArray();
        if (taxProducts && taxProducts.length) {
          packageData = packageData.concat(taxProducts);
        }
      }

      this.startWaiting();
      console.log(packageData);

      RegisterStore.dispatch('package', {
        packages: packageData,
      }).then((s) => {
        if (s.data.success === false) {
          this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
          this.endWaiting();
          return;
        }
        this.$store.commit('setremovePackageData', false);
        this.$store.commit('setCompanyId', s.data.data.id);
        this.callback(true);
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
